import React from "react";
import CTA from "./CTA";
import HeaderSocial from "./HeaderSocials";
import profilePic from "../../assets/profilepic.jpeg";
import { useMouseGlow } from "../../hooks/useMouseGlow";
import { useTypingAnimation } from "../../hooks/useTypingAnimation";
import "./header.css";

const Header = () => {
  const { elementRef, glowRef } = useMouseGlow();
  const summaryText = "Software Development Engineer with 2 years of experience building and maintaining production applications at scale. Experienced in solving performance challenges, client-server integrations & production issue resolution, with hands-on expertise in Java, Spring Boot, REST APIs, Microservices, and CI/CD. Seeking Software Engineer roles focused on backend or full-stack development.";
  const typedSummary = useTypingAnimation(summaryText, 30, 500);

  return (
    <header id="home" className="card-container">
      <div className="container header__container">
        {/* <h5>Hello I'm</h5> */}
        <h1>Tejas Patne</h1>
        <h5 className="text-light">Fullstack Developer | SDE @Carwale</h5>
        <p className="header__summary">
          {typedSummary}
          <span className="typing-cursor">|</span>
        </p>
        <CTA />
        <HeaderSocial />
        <section>
          <div className="wrapper" ref={elementRef}>
            <div className="glow" ref={glowRef}></div>
            <img src={profilePic} className="box" alt="Tejas Patne" />
          </div>
        </section>

        <a href="#contact" className="scroll__down">
          Scroll Down
        </a>
      </div>
    </header>
  );
};

export default Header;
